import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import DeltaWifiLocation from './DeltaWifiLocation';

const WrappedDeltaWifiLocation = (props) => {
  const { $rootScope } = props;
  return (
    <Provider store={$rootScope.reduxStore}>
      <DeltaWifiLocation {...props} />
    </Provider>
  );
};

WrappedDeltaWifiLocation.propTypes = {
  $rootScope: PropTypes.shape({
    reduxStore: PropTypes.shape({}),
  }).isRequired,
};

WrappedDeltaWifiLocation.defaultProps = {
};
export default WrappedDeltaWifiLocation;
